import { LoadingIndicator } from '@festo-ui/react';

import { useAppSelector } from '../../../../app/hooks';
import useTranslation from '../../../../features/translation/hooks/useTranslation';
import { FilterValueKey } from '../../../../features/filter/utils';
import './CriticalDisplay.scss';
import InfoButtonPopup from '../../../InfoButtonPopup';

interface CriticalProps {
  hasInfobutton?: boolean;
}

enum TranslationsKeys {
  CRITICAL_INFOBUTTON = 'resultCriticalNonCriticalInfoButton',
}

export default function CriticalDisplay({ hasInfobutton }: CriticalProps) {
  const t = useTranslation();
  const filterValues = useAppSelector((state) => state.filter.filtersValue);
  const { solution: solutionsValue, isResultsLoading } = useAppSelector((state) => state.results);
  const isCritical = solutionsValue?.pressureTypeTranslationKey;

  if (filterValues[FilterValueKey.CALCULATION_RESULT] !== 'QN') return null;

  if (isResultsLoading === 'idle' || isResultsLoading === 'pending' || !isCritical) {
    return (
      <div className="pt-3">
        <LoadingIndicator size="small" />
      </div>
    );
  }

  return (
    <>
      {isCritical === 'underCritical' ? (
        <div className="iscritical2">
          <i className="fwe-icon fwe-icon-menu-check ocritical"></i>
          <span className="critical-text">{t(isCritical)}</span>
          {hasInfobutton ? (
            <InfoButtonPopup className="infobutton">
              <p>{t(TranslationsKeys.CRITICAL_INFOBUTTON)}</p>
            </InfoButtonPopup>
          ) : null}
        </div>
      ) : (
        <div className="iscritical2 is-actually-critical">
          <i className="fwe-icon fwe-icon-status-warning ocritical"></i>
          <span className="critical-text">{t(isCritical)}</span>
          {hasInfobutton ? (
            <InfoButtonPopup className="infobutton">
              <p className="infobutton-text">{t(TranslationsKeys.CRITICAL_INFOBUTTON)}</p>
            </InfoButtonPopup>
          ) : null}
        </div>
      )}
    </>
  );
}
